import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["music-and-running"]!;

export function Body() {
  return (
    <>
      <p>
        Many runners never go out without music. Others prefer silence. Does music actually help?
        A meta-analysis of 139 studies looked at the effects.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers from Australia and the UK pooled 139 studies with almost 3,600 participants
        who exercised with and without music. They looked at mood, how hard the exercise felt,
        heart rate, oxygen uptake and performance.
      </p>

      <h2>What they found</h2>
      <p>
        With music, people felt better during exercise, the effort felt a little easier and
        performance improved. Oxygen uptake was slightly lower, a sign of more efficient
        exercise. Heart rate did not change.
      </p>
      <p>
        Fast music improved performance more than slow or medium music. The effect was larger in
        general exercise than in competitive sport.
      </p>

      <h2>What it means for you</h2>
      <p>
        If music makes your runs more enjoyable, use it. It can make a hard session feel a bit
        easier and help on days when motivation is low.
      </p>
      <p>
        Keep the volume low enough to hear traffic and other people. Some races don't allow
        headphones, so check the rules, and get used to running without music if you need to.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The effects were small to moderate, and the studies varied a lot. Most tested short
        efforts, not long runs or races.
      </p>

      <h2>How we use it</h2>
      <p>
        Music doesn't change your targets in PX7 Training. If music makes a session feel easier,
        your rating afterwards will show it.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Terry et al. (2020), Effects of music in exercise and sport: a meta-analytic review.{" "}
          <a href="https://doi.org/10.1037/bul0000216">Psychological Bulletin</a>.
        </li>
      </ul>
    </>
  );
}
